import { render } from "./MainHeading.vue?vue&type=template&id=d31f6e94&scoped=true"
import script from "./MainHeading.vue?vue&type=script&lang=js"
export * from "./MainHeading.vue?vue&type=script&lang=js"

import "./MainHeading.vue?vue&type=style&index=0&id=d31f6e94&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d31f6e94"]])

export default __exports__